export namespace URLParamConst
{
  export const UtmParams = 'utmParams';
  export const UtmCampaign = 'utm_campaign';
  export const UtmMedium = 'utm_medium';
  export const UtmSource = 'utm_source';
}
